import React from 'react';
import { BreadcrumbGroup } from '@cloudscape-design/components';
import { useLocation, useHistory } from 'react-router-dom';
import { getFundRequestId, isFundRequestDetailsPage } from '../utils/urlHelper';

/**
 * Dynamic breadcrumb component following APFP pattern
 * Automatically generates breadcrumbs based on current route
 */
const Breadcrumbs = () => {
  const location = useLocation();
  const history = useHistory();

  const handleChronosClick = (e) => {
    e.preventDefault();
    history.push('/dashboard');
  };

  const handleBackToList = (e) => {
    e.preventDefault();
    history.push('/dashboard');
  };

  const getBreadcrumbItems = () => {
    const { pathname } = location;
    
    if (isFundRequestDetailsPage()) {
      const fundRequestId = getFundRequestId();
      return [
        { text: 'Chronos', href: '/dashboard', onClick: handleChronosClick },
        { text: 'Validated Fund Requests', href: '/dashboard', onClick: handleBackToList },
        { text: fundRequestId || 'Details', href: '#' }
      ];
    } else if (pathname === '/fund-request-queue') {
      return [
        { text: 'Chronos', href: '/dashboard', onClick: handleChronosClick },
        { text: 'Fund Request Queue', href: '#' }
      ];
    } else if (pathname === '/event-history') {
      return [
        { text: 'Chronos', href: '/dashboard', onClick: handleChronosClick },
        { text: 'Event History', href: '#' }
      ];
    } else if (pathname === '/reporting') {
      return [
        { text: 'Chronos', href: '/dashboard', onClick: handleChronosClick },
        { text: 'Reporting', href: '#' }
      ];
    } else {
      return [
        { text: 'Chronos', href: '/dashboard', onClick: handleChronosClick },
        { text: 'Validated Fund Requests', href: '#' }
      ];
    }
  };

  return (
    <BreadcrumbGroup
      items={getBreadcrumbItems()}
      ariaLabel="Breadcrumbs"
    />
  );
};

export default Breadcrumbs;